export default __webpack_public_path__ + "static/media/contacts.e41cb3da.svg";